import { useState } from "react";

export function usePropertiesData(supabase, landlordId, tenants, reload) {
  const [properties, setProperties] = useState([]);
  const [showAddProperty, setShowAddProperty] = useState(false);
  const [editProperty, setEditProperty] = useState(null);
  const [newProperty, setNewProperty] = useState({ address: "", city: "", state: "", zip: "", units: 1, notes: "" });
  const [propTab, setPropTab] = useState("properties");
  const [selectedProperty, setSelectedProperty] = useState(null);

  const seedDefaultProperties = async () => {
    const defaults = [
      { address: "27 Madison Ave",     units: 1, notes: null },
      { address: "45 Madison Ave",     units: 1, notes: null },
      { address: "155 West Siino Ave", units: 3, notes: "Unit 1, Unit 2, Unit 3" },
      { address: "75 Siino Ave",       units: 1, notes: null },
    ];
    const { error } = await supabase.from("properties").insert(defaults.map(p => ({ ...p, user_id: landlordId })));
    if (error) { alert("Error seeding properties: " + error.message); return; }
    reload();
  };

  const addProperty = async () => {
    if (!newProperty.address || !newProperty.city || !newProperty.state || !newProperty.zip) return;
    setShowAddProperty(false);
    const { error } = await supabase.from("properties").insert([{
      address: newProperty.address.trim(),
      city: newProperty.city.trim(),
      state: newProperty.state,
      zip: newProperty.zip.trim(),
      units: parseInt(newProperty.units) || 1,
      notes: newProperty.notes || null,
      user_id: landlordId,
    }]);
    if (error) { alert("Error adding property: " + error.message); return; }
    setNewProperty({ address: "", city: "", state: "", zip: "", units: 1, notes: "" });
    reload();
  };

  const savePropertyEdit = async () => {
    if (!editProperty?.address) return;
    const { error } = await supabase.from("properties").update({
      address: editProperty.address.trim(),
      units: parseInt(editProperty.units) || 1,
      notes: editProperty.notes || null,
    }).eq("id", editProperty.id);
    if (error) { alert("Error: " + error.message); return; }
    setEditProperty(null);
    reload();
  };

  const deleteProperty = async (id) => {
    if (!window.confirm("Delete this property? This won't affect tenant records.")) return;
    await supabase.from("properties").delete().eq("id", id);
    reload();
  };

  const syncPropertiesFromTenants = async () => {
    const candidates = tenants.filter(t => t.address && t.address.trim());
    const toInsert = [];
    for (const t of candidates) {
      const addr = t.address.trim();
      const alreadyQueued = toInsert.some(r => r.address.toLowerCase() === addr.toLowerCase());
      const { data: existing } = await supabase.from("properties").select("id").eq("user_id", t.user_id).ilike("address", addr).maybeSingle();
      if (!existing && !alreadyQueued) {
        toInsert.push({ address: addr, units: 1, user_id: t.user_id });
      }
    }
    if (toInsert.length === 0) { alert("All tenant addresses already exist as properties — nothing to sync."); return; }
    const { error } = await supabase.from("properties").insert(toInsert);
    if (error) { alert("Sync error: " + error.message); return; }
    alert(`Synced ${toInsert.length} new propert${toInsert.length === 1 ? "y" : "ies"} from tenant addresses.`);
    reload();
  };

  return {
    properties, setProperties,
    showAddProperty, setShowAddProperty,
    newProperty, setNewProperty,
    editProperty, setEditProperty,
    propTab, setPropTab,
    selectedProperty, setSelectedProperty,
    seedDefaultProperties, addProperty, savePropertyEdit, deleteProperty, syncPropertiesFromTenants,
  };
}
